import request from '@teetsh/app/src/utils/request';
import { useConfigurationDisplayValue } from '@teetsh/app/src/containers/CahierJournal/useCJConfigurationDisplay';
import Cookies from 'js-cookie';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

interface Track {
  type: 'event';
  eventName: string;
  payload?: Record<string, string | undefined>;
}

interface PageView {
  type: 'pageview';
  title: string;
  path: string;
  payload?: Record<string, string | undefined>;
}

const appVersion = __APP_VERSION__ || 'unknown';

// all envs except test and production
const shouldLogEvents = !['production', 'test'].includes(
  import.meta.env.VITE_ENVIRONMENT,
);

function track(event: Track | PageView) {
  const requestURL = '/user/track';
  const eventWithAppVersion = {
    ...event,
    payload: {
      ...event.payload,
      appVersion,
    },
  };

  // Log analytics events in non-production environments
  if (shouldLogEvents) {
    // eslint-disable-next-line no-console
    console.info('%c[Analytics Event]', 'color: #3b82f6', eventWithAppVersion);
  }

  if (Cookies?.get('teetshadmin')) {
    // return empty promise to avoid sending the event to the server
    return Promise.resolve();
  }

  return request(requestURL, {
    method: 'POST',
    body: eventWithAppVersion,
  });
}

export function trackEvent(
  eventName: string,
  payload?: Record<string, string | undefined>,
) {
  return track({
    type: 'event',
    eventName,
    payload,
  });
}

function useTrackPageView(
  title: string,
  payload?: Record<string, string | undefined>,
) {
  const location = useLocation();
  useEffect(() => {
    track({
      type: 'pageview',
      title,
      path: location.pathname,
      payload,
    });
  }, [title]);
}

interface Props {
  title: string;
  enableCJConfigCapture?: boolean;
  children: any;
}

export function PageTrackerWrapper(props: Props) {
  const { globalScroll, expanded } = useConfigurationDisplayValue();
  const payload = props.enableCJConfigCapture
    ? {
        globalScroll: globalScroll ? 'true' : 'false',
        columnWidth: expanded ? 'grow' : 'fit',
      }
    : undefined;
  useTrackPageView(props.title, payload);
  return props.children;
}
